import { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { ROUTE_ORGANISATIONS } from '../../components/Routing/routeHelpers';
import appLocalStorage from '../../utils/AppLocalStorage';
import { OrgMembersViewTabs } from '../OrganisationMembers/types';

const tabPaths: any = {
  [OrgMembersViewTabs.Members]: ROUTE_ORGANISATIONS.organisationMembers,
  [OrgMembersViewTabs.Settings]: ROUTE_ORGANISATIONS.organisationSettings,
};

interface Props {
  currentTab: OrgMembersViewTabs;
}

const useOrgMembersTab = ({ currentTab }: Props) => {
  const [selectedTab, setSelectedTab] =
    useState<OrgMembersViewTabs>(currentTab);
  const history = useHistory();
  const { code } = useParams<{ code: string }>();
  const [searchText, setSearchText] = useState('');

  const handleTabSelection = (id: any) => {
    setSelectedTab(id as OrgMembersViewTabs);
    const updateUrl = tabPaths[id];
    history.push(updateUrl.replace(':code', code));
  };

  return {
    searchText,
    setSearchText,
    selectedTab,
    isViewOnlyRole: appLocalStorage.isViewOnlyRole(),
    handleTabSelection,
  };
};

export default useOrgMembersTab;
